<template>
    <div class="wrapper">
        <sub-ibox-title :is-show-back=true>
            <p slot="title">{{params.id ? '编辑' : '新增'}}商品分类</p>
        </sub-ibox-title>
        <section class="content">
            <div class="detail-cont">
                <z-input title="名称" v-model="params.name" :isMust = true maxlength=5></z-input>
                <div class="p-10 c-g fx shop-tips">
					<p class="w120 m-r-5"></p>
					<div class="pic-tips">Tips：分类名称最多5个字符</div>
				</div>
                <div class="fx fx-y-center m-t-20">
					<p class="title fx w120 m-r-5"><i class="ask">*</i><span class="fx-fill">图标</span></p>
					<!--<z-up-file :listArr="picList"></z-up-file>-->
					<z-upload :file-url='params.face' :on-success="handleUploadSuccess"></z-upload>
					<div class="pic-tips m-l-10">建议尺寸：200*200</div>
				</div>
            </div>
            <div class="m-t-20 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleSaveGoodsType">保存</a>
			</div>
        </section>
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex'
    export default {
        name: 'ClassifyEdit',
        data() {
            return {
		      	params: {
		      		id: null,
		      		name: '',
		      		face: null,
		      	}
            }
        },
        mounted() {
			this.params.id = this.$route.query.id || null
			if(this.$re_Number(this.params.id)) this.handleGetGoodsTypeDetail();
			
		},
        /*
         * 事件处理
         */
        methods: {
        	//图片上传成功回调
			handleUploadSuccess(url){
				this.params.face = url
			},
			//保存分类
			handleSaveGoodsType() {
				if (!this.params.name) return this.$warning('请输入分类名称');
				if (!this.params.face) return this.$warning('请上传分类图标');
				
				this.saveGoodsType(this.params).then(()=>{
					this.$success('保存成功');
					this.$back();
				},(error)=>{
					this.$errorMsg(error);
				})
			},
			
			//获取分类详情
			handleGetGoodsTypeDetail() {
				this.getGoodsTypeDetail({id: this.params.id}).then((data)=>{
					this.params.name = data.name;
					this.params.face = data.face;
				},()=>{
					this.$errorMsg('获取数据失败/(ㄒoㄒ)/~~')
				})
			},
			...mapActions(['saveGoodsType', 'getGoodsTypeDetail']),
        }
    }
</script>
<style lang="scss" scoped>
    @import "src/assets/css/common.scss";
    #content {
        min-height: px-em(400px);
    }
    .content{
    	border-top: none;
    }
    .detail-cont {
        width: px-em(1200px);
        .question-api{
        	position: relative;
        	width: px-em(120px);
        	height: px-em(120px);
        	border: 1px solid $color-border;
        	overflow: hidden;
        	&:hover {
				.edit {
					opacity: 1;
				}
			}
        	input {
				display: inline-block;
				width: px-em(120px);
        		height: px-em(120px);
				opacity: 0;
				position: relative;
				z-index: 99;
				cursor: pointer;
			}
			img {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
			.edit {
				opacity: 0;
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.3);
				transition: all 0.2s ease;
				.icon {
					transition: all 0.2s ease;
					color: #fff;
					font-size: px-em(32px);
				}
			}
        }
        .tips-sort{
        	padding-left: px-em(170px);
        	padding-top: px-em(10px);
        	color: $color-gray;
        }
    }
    .file-btn {
		position: relative;
		width: px-em(200px);
		height: px-em(50px);
		overflow: hidden;
		cursor: pointer;
		&:hover {
			a {
				opacity: 0.8;
			}
		}
		a {
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
		input {
			position: absolute;
			display: block;
			opacity: 0;
			z-index: 1;
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.wrapper{
			min-width: px-em(800px);
			.detail-cont{
				width: px-em(700px);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// ClassifyEdit.vue?a635cbb4